/* eslint-disable camelcase */
/* eslint-disable react/display-name */
/**
 * @file RiskRegisterView.jsx
 * @author Daniel Aguirre
 * @description RiskRegister View Page
 */

// Dependencies
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import DashboardCard from 'components/DashboardCard';
import { useHistory } from 'react-router';

import DashboardProgress from 'components/Charts/DashboardProgress';
import styleGuideColors from 'commons/styleGuideColors';

/**
 * RiskRegister View
 * @param { Object } dashboardStaffActions - DashboardStaff Actions.
 * @return { Node } React node.
 */

function RiskRegisterView({ dashboardStaffActions, clinicId }) {
  const { t: translate } = useTranslation();
  const history = useHistory();
  const [chartData, setChartData] = useState([]);

  const { getRiskRegister } = dashboardStaffActions;

  const getProgressData = (key, color, total) => {
    return {
      label: translate(`dashboardStaff.${key.registro_riesgo}`),
      value: ((key.cantidad * 100) / total).toFixed(3).slice(0, -1),
      color,
      cantidad: key.cantidad,
      classification: key.registro_riesgo
    };
  };

  const onGetData = (_, resp) => {
    if (resp?.data && resp?.data?.length !== 0) {
      let data = {};
      let progress = {};
      let max = {};
      let total = 0;
      resp?.data.forEach(({ cantidad }) => {
        total += cantidad;
      });

      resp?.data?.forEach((itm) => {
        if (itm.registro_riesgo === 'Si coincide') {
          progress = getProgressData(
            itm,
            styleGuideColors.baxterBrandTeal,
            total
          );
        } else {
          max = getProgressData(itm, styleGuideColors.alertError, total);
        }
      });
      data = {
        progress,
        max
      };
      setChartData(data);
    } else {
      setChartData([]);
    }
  };

  useEffect(() => {
    setChartData(null);
    getRiskRegister({ clinicId }, onGetData);
  }, [clinicId, translate]);

  const handleDetailClick = (section) => {
    const { cantidad: totalItems, classification } = chartData[section];
    history.push(
      `/main/dashboard-detail/risk-register/${classification}/${totalItems}`
    );
  };

  return (
    <DashboardCard id="F19" loading={!chartData}>
      <DashboardProgress
        title={translate('dashboardStaff.riskRegister')}
        max={chartData?.max}
        progress={chartData?.progress}
        onDetailClick={handleDetailClick}
      />
    </DashboardCard>
  );
}

/**
 * Component definition of proptypes.
 */
RiskRegisterView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getRiskRegister: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default RiskRegisterView;
